import './styled-category.ts';

if (window && window.searchResult && window.searchResult.facets) {
	require('./index.js');
}

if (window.publicPath) __webpack_public_path__ = window.publicPath;
